import { render, staticRenderFns } from "./TrafficJam.vue?vue&type=template&id=c2637ff2&"
import script from "./TrafficJam.vue?vue&type=script&lang=js&"
export * from "./TrafficJam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports